import { sendEvent } from 'libs/event';

let triggerValidateInteraction = false;
let thenableRef;

/**
 * send valid pv tracking after user interacts with the page.
 * e.g. fn(), fn(false), fn(true, options), fn(options)
 * @param {boolean} sendValidPv whether to send tracking request
 * @param {object} extra extra information of this tracking
 */
export default function validPv(sendValidPv = true, extra = {}) {
    /* eslint-disable no-param-reassign */
    if (arguments.length === 1 && typeof sendValidPv === 'object') {
        extra = sendValidPv;
        sendValidPv = true;
    }
    /* eslint-enable no-param-reassign */
    if (triggerValidateInteraction) return Promise.resolve();
    if (thenableRef) {
        return thenableRef;
    }
    thenableRef = new Promise((resolve, reject) => {
        const validClickHandler = () => {
            // eslint-disable-next-line no-use-before-define
            addOrRemoveListeners(false);
        };
        const scrollHandler = () => {
            // eslint-disable-next-line no-use-before-define
            addOrRemoveListeners(false);
        };
        const addOrRemoveListeners = (add: boolean) => {
            // iOS UIWebview click 和 scroll 事件均不会及时触发
            // 考虑改成 touchstart ？
            document[add ? 'addEventListener' : 'removeEventListener'](
                'click',
                validClickHandler,
                true
            );
            document[add ? 'addEventListener' : 'removeEventListener'](
                'scroll',
                scrollHandler,
                false
            );
            if (!add) {
                if (sendValidPv) sendEvent('valid_page_view', { ...extra });
                triggerValidateInteraction = true;
                resolve();
            }
        };

        addOrRemoveListeners(true);
    });

    return thenableRef;
}
